import { forwardRef, type HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowIcon from '@assets/img/icons/arrow-top.svg?react';
import cn from 'classnames';

import css from './styles.module.scss';

const BackButton = forwardRef<
  HTMLButtonElement,
  HTMLAttributes<HTMLButtonElement>
>((props, ref) => {
  const { t } = useTranslation();

  return (
    <button
      ref={ref}
      {...props}
      className={cn(props.className, css.backButton)}
    >
      <span className="leading-none text-[10px] text-white/60">
        {t('Back')}
      </span>
      <ArrowIcon className="-rotate-90 text-white size-[24px]" />
    </button>
  );
});

export { BackButton };
